module.exports = __webpack_public_path__ + "static/media/11.4a8c8890.png";